export const toReadableTotal = (total) => {
    return (total / 100).toFixed(2);
  }
  
  export const toReadableTimestamp = (timestamp) => {
    let date;

    if (typeof timestamp === 'number') {
        date = new Date(timestamp * 1000); // Unix timestamp (seconds)
    } else if (typeof timestamp === 'string') {
        // Try parsing as ISO date first
        const isoDate = new Date(timestamp);
        if (!isNaN(isoDate.getTime())) {
            date = isoDate;
        } else {
            // Otherwise, try parsing as Unix timestamp string
            const numericTimestamp = parseFloat(timestamp);
            if (isNaN(numericTimestamp)) {
                return "Invalid timestamp";
            }
            date = new Date(numericTimestamp * 1000);
        }
    } else {
        return "Invalid timestamp";
    }

    if (isNaN(date.getTime())) {
        return "Invalid timestamp";
    }

    const options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString("en-us", options) + " at " + date.toLocaleTimeString("en-us", { hour: '2-digit', minute: '2-digit' });
}